const autofocusEventHandler = {
  __eventHandler: null,
  __key: null,
  __ignoredKeys: [
    " ", // Space
    "Spacebar", // Space
    "Escape", // Escape
    "Backspace", // Backspace
    "Tab", // Tab,
    "Paste" // Paste
  ],
  __ignoredElementTypes: ["INPUT", "TEXTAREA"],
  __handleEvent(event, handler) {
    const target = event.target || event.srcElement;

    if (this.__ignoredElementTypes.indexOf(target.tagName) !== -1 || !this.__isIgnoredKey(event)) {
      return;
    }

    handler(event);
  },
  __isIgnoredKey(event) {
    // Check for CTRL or CMD keypresses
    if (event.ctrlKey || event.metaKey) {
      return false;
    }

    // Support: Chrome 51, IE 9, Opera 38
    if (event.key) {
      if (event.key.length > 1 || this.__ignoredKeys.indexOf(event.key) !== -1) {
        return false;
      }

      // Unsupported
    } else {
      return false;
    }

    return true;
  },
  addEventListener(key, eventHandler = () => undefined) {
    this.__key = key;
    this.__eventHandler = (event) => {
      this.__handleEvent(event, eventHandler);
    };

    window.document.addEventListener(this.__key, this.__eventHandler, true);
  },
  removeEventListener() {
    window.document.removeEventListener(this.__key, this.__eventHandler, true);
  }
};

export default autofocusEventHandler;
